import type { UseEditorOptions } from '@tiptap/react'

import { createTiptapExtensions } from '@/lib/tiptap/extensions'
import {
  normalizeTiptapValue,
  resolveTiptapDirection
} from '@/lib/tiptap/tiptap-utils'

import type { CreateTiptapEditorConfigOptions } from '@/lib/tiptap/types'

export const createTiptapEditorConfig = ({
  content,
  direction,
  editable = true,
  onUpdate,
  placeholder
}: CreateTiptapEditorConfigOptions = {}): UseEditorOptions => {
  const resolvedDirection = resolveTiptapDirection(direction)

  return {
    content: normalizeTiptapValue(content),
    editable,
    editorProps: {
      attributes: {
        class: 'tiptap-content max-w-full focus:outline-none',
        dir: resolvedDirection
      }
    },
    extensions: createTiptapExtensions({
      direction: resolvedDirection,
      placeholder
    }),
    immediatelyRender: false,
    onUpdate: ({ editor }) => {
      onUpdate?.(editor.getHTML())
    }
  }
}
